import { render, staticRenderFns } from "./head2.vue?vue&type=template&id=6ec4e412&scoped=true"
import script from "./head2.vue?vue&type=script&lang=js"
export * from "./head2.vue?vue&type=script&lang=js"
import style0 from "./head2.vue?vue&type=style&index=0&id=6ec4e412&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec4e412",
  null
  
)

export default component.exports